const categoryKeys = {
  all: [{ scope: "ecomcategories_cty" }] as const,

  list: (params?: any) =>
    [{ scope: "ecomcategories_cty", type: "list", ...params }] as const,

  detail: (slug?: string) =>
    [{ scope: "ecomcategories_cty", type: "detail", slug }] as const,
};

export default categoryKeys;
